import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "space-y-3 rounded-xl border border-slate-200 bg-white p-4"
};
const _hoisted_2 = {
  class: "flex items-center justify-between"
};
const _hoisted_3 = {
  class: "text-sm font-semibold text-slate-700"
};
const _hoisted_4 = {
  class: "flex flex-wrap items-center gap-1 rounded-lg border border-slate-200 bg-white p-2"
};
const _hoisted_5 = {
  class: "max-h-72 overflow-y-auto pr-1"
};
const _hoisted_6 = {
  class: "mb-2 text-[11px] font-bold uppercase tracking-wide text-slate-400"
};
const _hoisted_7 = {
  class: "flex items-start justify-between w-full"
};
const _hoisted_8 = {
  class: "text-sm font-semibold text-slate-800"
};
const _hoisted_9 = {
  key: 0,
  class: "ml-2 inline-flex items-center rounded border border-emerald-300 bg-emerald-100 px-1.5 py-0.5 font-mono text-[0.75em] text-emerald-900 whitespace-nowrap"
};
const _hoisted_10 = {
  class: "font-mono text-xs text-slate-600"
};
import { computed, ref } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlSwitch from '@/components/LlSwitch.vue';
export default {
  __name: 'SettlementEditorSection',
  props: {
    title: {
      type: String,
      required: true
    },
    enabled: {
      type: Boolean,
      default: true
    },
    keywordGroups: {
      type: Array,
      default: () => []
    },
    boldActive: {
      type: Boolean,
      default: false
    },
    italicActive: {
      type: Boolean,
      default: false
    },
    bulletListActive: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:enabled', 'toggle-bold', 'toggle-italic', 'toggle-bullet-list', 'undo', 'redo', 'insert-keyword'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const keywordSearch = ref('');
    const keywordMenuOpen = ref(false);
    const filteredKeywordGroups = computed(() => {
      const normalizedSearch = keywordSearch.value.trim().toLowerCase();
      if (!normalizedSearch) {
        return props.keywordGroups;
      }
      return props.keywordGroups.map(group => ({
        ...group,
        keywords: group.keywords.filter(keyword => {
          const haystack = `${keyword.name} ${keyword.token} ${keyword.description}`.toLowerCase();
          return haystack.includes(normalizedSearch);
        })
      })).filter(group => group.keywords.length > 0);
    });
    const onKeywordClick = token => {
      emit('insert-keyword', token);
      keywordMenuOpen.value = false;
    };
    const editorClasses = computed(() => {
      if (props.enabled) {
        return 'rounded-lg border border-slate-200 bg-white p-3';
      }
      return 'pointer-events-none rounded-lg border border-slate-100 bg-slate-50 p-3 opacity-60';
    });
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_text_field = _resolveComponent("v-text-field");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_list = _resolveComponent("v-list");
      const _component_v_alert = _resolveComponent("v-alert");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_menu = _resolveComponent("v-menu");
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1), _createVNode(LlSwitch, {
        "model-value": __props.enabled,
        inset: "",
        color: "primary",
        label: __props.enabled ? 'Enabled' : 'Disabled',
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.$emit('update:enabled', $event))
      }, null, 8, ["model-value", "label"])]), _createElementVNode("div", _hoisted_4, [_createVNode(LlSecondaryButton, {
        icon: "mdi-format-bold",
        "aria-label": "Bold",
        size: "small",
        color: __props.boldActive ? 'grey-lighten-2' : '',
        variant: "text",
        disabled: !__props.enabled,
        class: "h-8 min-w-0 text-slate-700",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('toggle-bold'))
      }, null, 8, ["color", "disabled"]), _createVNode(LlSecondaryButton, {
        icon: "mdi-format-italic",
        "aria-label": "Italic",
        size: "small",
        color: __props.italicActive ? 'grey-lighten-2' : '',
        variant: "text",
        disabled: !__props.enabled,
        class: "h-8 min-w-0 text-slate-700",
        onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('toggle-italic'))
      }, null, 8, ["color", "disabled"]), _createVNode(LlSecondaryButton, {
        icon: "mdi-format-list-bulleted",
        "aria-label": "Bulleted list",
        size: "small",
        color: __props.bulletListActive ? 'grey-lighten-2' : '',
        variant: "text",
        disabled: !__props.enabled,
        class: "h-8 min-w-0 text-slate-700",
        onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('toggle-bullet-list'))
      }, null, 8, ["color", "disabled"]), _createVNode(LlSecondaryButton, {
        icon: "mdi-undo",
        "aria-label": "Undo",
        size: "small",
        variant: "text",
        disabled: !__props.enabled,
        class: "h-8 min-w-0 text-slate-700",
        onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('undo'))
      }, null, 8, ["disabled"]), _createVNode(LlSecondaryButton, {
        icon: "mdi-redo",
        "aria-label": "Redo",
        size: "small",
        variant: "text",
        disabled: !__props.enabled,
        class: "h-8 min-w-0 text-slate-700",
        onClick: _cache[5] || (_cache[5] = $event => _ctx.$emit('redo'))
      }, null, 8, ["disabled"]), _createVNode(_component_v_menu, {
        modelValue: keywordMenuOpen.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => keywordMenuOpen.value = $event),
        location: "bottom end",
        "close-on-content-click": false,
        class: "ml-auto"
      }, {
        activator: _withCtx(({
          props: activatorProps
        }) => [_createVNode(LlSecondaryButton, _mergeProps(activatorProps, {
          disabled: !__props.enabled,
          variant: "outlined",
          class: "ml-auto h-8 px-3 text-xs font-semibold normal-case text-slate-700"
        }), {
          default: _withCtx(() => [_createVNode(_component_v_icon, {
            size: "14",
            class: "mr-1"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("mdi-code-braces", -1)]))]),
            _: 1
          }), _cache[9] || (_cache[9] = _createTextVNode(" Insert keyword ", -1))]),
          _: 1
        }, 16, ["disabled"])]),
        default: _withCtx(() => [_createVNode(_component_v_card, {
          class: "w-[360px] max-w-full rounded-xl border border-slate-200 !bg-[rgb(var(--v-theme-surface))] shadow-xl"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card_text, {
            class: "space-y-3 p-3"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_text_field, {
              modelValue: keywordSearch.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => keywordSearch.value = $event),
              variant: "outlined",
              density: "compact",
              placeholder: "Search keywords...",
              "prepend-inner-icon": "mdi-magnify",
              "hide-details": ""
            }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredKeywordGroups.value, group => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: group.group
              }, [_createElementVNode("div", _hoisted_6, _toDisplayString(group.group), 1), _createVNode(_component_v_list, {
                density: "compact",
                class: "mb-3 rounded-lg border border-slate-200 p-1"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.keywords, keyword => {
                  return _openBlock(), _createBlock(_component_v_list_item, {
                    key: keyword.name,
                    class: "rounded-md",
                    onClick: $event => onKeywordClick(keyword.token)
                  }, {
                    title: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(keyword.description), 1), keyword.sampleValue ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(keyword.sampleValue), 1)) : _createCommentVNode("", true)])]),
                    subtitle: _withCtx(() => [_createElementVNode("span", _hoisted_10, _toDisplayString(keyword.token), 1)]),
                    _: 2
                  }, 1032, ["onClick"]);
                }), 128))]),
                _: 2
              }, 1024)], 64);
            }), 128)), filteredKeywordGroups.value.length === 0 ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 0,
              type: "info",
              variant: "tonal",
              density: "compact"
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" No variables match your search. ", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true)])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", {
        class: _normalizeClass(editorClasses.value)
      }, [_renderSlot(_ctx.$slots, "default")], 2)]);
    };
  }
};